import { PagePaths } from '@revelio/core';

/**
 * Paths where the global assistant is hidden. Custom Dash report editors live
 * at `/report/:templateId` and use the in-page Report AI assistant instead.
 * Legacy MW report builder, sample reports, and the reports list remain visible
 * so report-offer handoffs can continue in chat.
 *
 * Economic Impact has no assistant tool behind it, so the FAB is hidden there
 * too. Its segment is a literal rather than a `PagePaths` member: that route
 * is declared inline in `next.tsx`.
 */
const hiddenGlobalAIAssistantPathSegments = [
  'admin',
  'manage',
  'report',
  'economic-impact',
  PagePaths.DATA_BUILDER,
  PagePaths.DATA_BUILDER_SHARE,
  PagePaths.DATA_BUILDER_STATUS,
  `${PagePaths.DELIVERABLES}/${PagePaths.DATA_ENRICHMENT}`,
  PagePaths.RESUME_ENRICHMENT,
  PagePaths.HEALTH_CHECK,
] as const;

function pathnameMatchesTopLevelSegment(
  pathname: string,
  segment: string
): boolean {
  return pathname === `/${segment}` || pathname.startsWith(`/${segment}/`);
}

export function shouldHideGlobalAIAssistantForPathname(
  pathname: string
): boolean {
  return hiddenGlobalAIAssistantPathSegments.some((segment) =>
    pathnameMatchesTopLevelSegment(pathname, segment)
  );
}
